export const SELECT_ROOM = 'messages/SELECT_ROOM'
export const PUSH_DATA = 'messages/PUSH_DATA'
export const PUSH_HISTORY = 'messages/PUSH_HISTORY'
